import styled from 'styled-components';
import { rem } from 'polished';

export const FooterContainer = styled.footer`
  padding: ${rem('40px')} 0;
  background-color: ${({ theme }) => theme.colors.main};

  background-image: url(${({ $bgImage }) => $bgImage});
  background-repeat: no-repeat;

  color: ${({ theme }) => theme.colors.white};

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    padding-top: ${rem('20px')};
  }
`;

export const Container = styled.div`
  margin: 0 auto;
  padding: 0 ${rem('16px')};
  width: 100%;
  box-sizing: border-box;

  @media ${({ theme }) => theme.mediaQueries.large} {
    max-width: ${rem('990px')};
  }

  @media ${({ theme }) => theme.mediaQueries.largeMax} {
    max-width: 95%;
  }
`;

export const InfoContainer = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  gap: ${rem('40px')};

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    grid-template-columns: 1fr 1fr;
  }

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

export const BrandContainer = styled.div`
  font-size: ${rem('50px')};
  display: flex;
  gap: ${rem('15px')};
  align-items: center;
  margin-bottom: ${rem('20px')};

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    justify-content: center;
  }
`;

export const BranText = styled.span`
  font-family: 'Righteous';
  font-weight: 700;
  width: min-content;
  font-size: ${rem('30px')};
`;

export const Phone = styled.a`
  display: block;
  font-weight: 600;
  color: white;
  text-decoration: none;
  margin-bottom: ${rem('8px')};
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const CopyRight = styled.div`
  font-size: ${rem('11px')};
  font-weight: 400;
  opacity: 0.7;
  margin-top: ${rem('16px')};
  line-height: 1.5;
`;

export const Location = styled.div`
  font-weight: 700;
  font-size: ${rem('16px')};
  margin-bottom: ${rem('12px')};
  color: #34d399;
`;

export const List = styled.ul`
  list-style: none;
  padding-left: 0;
  margin: 0;
  font-weight: 400;
  font-size: ${rem('14px')};
  line-height: 1.6;

  & li {
    &:not(:last-child) {
      margin-bottom: ${rem('12px')};
    }
  }
`;

export const ContactLink = styled.a`
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: ${rem('8px')};
  font-size: ${rem('14px')};
  margin-bottom: ${rem('8px')};
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    justify-content: center;
  }
`;

export const Tagline = styled.div`
  font-size: ${rem('14px')};
  color: #a78bfa;
  margin-bottom: ${rem('16px')};
  font-weight: 500;
`;

export const SectionTitle = styled.div`
  font-weight: 700;
  font-size: ${rem('14px')};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: ${rem('16px')};
  color: #34d399;
`;
